<div class="track-my-location-container">
  <div class="track-my-location">

    <div class="header col-12 md:col-12 lg:col-12 sm:col-12">
      <div class="col-6 md:col-12 lg:col-6 sm:col-12 contact-info">
        <a href="" target="_blank">
          <img width="200" src="/assets/images/temp/MI_black_logo.png">
        </a>
      </div>
    </div>
    <div class=" col-nopad col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>

    <div class="gap-12 md:col-12 lg:col-12">
      <div class="gap-12 md:col-12 lg:col-12 grid">
        <div class="gap-2 md:col-6 lg:col-2"><strong translate>label_phone_number</strong></div>
        <div class="gap-2 md:col-6 lg:col-2">{{supportData.numCountryCode}} {{supportData.phoneNumber}} </div>
      </div>
      <div class="gap-12 md:col-12 lg:col-12 grid">
        <div class="gap-2 md:col-6 lg:col-2"><strong translate>label_email</strong></div>
        <div class="gap-2 md:col-6 lg:col-2">{{supportData.email}}</div>
      </div>
      <div class="gap-12 md:col-12 lg:col-12 grid">
        <div class="gap-2 md:col-6 lg:col-2"><strong translate>label_address</strong></div>
        <div class="gap-2 md:col-6 lg:col-2">
          {{supportData.addressLine1? supportData.addressLine1:''}}
          {{supportData.addressLine2? supportData.addressLine2:''}}
        </div>
      </div>
    </div>
  </div>
</div>